import { forwardRef } from "react";

import * as RadixLabel from "@radix-ui/react-label";
import { cva } from "class-variance-authority";
import type { VariantProps } from "class-variance-authority";
import { twMerge } from "tailwind-merge";

const formLabel = cva("block text-sm font-medium leading-6 text-gray-900");

type LabelVariantProps = VariantProps<typeof formLabel>;

export type Props = LabelVariantProps & {
  text: string;
  htmlFor?: string;
  className?: string;
  required?: boolean;
} & React.HTMLAttributes<HTMLLabelElement>;

const FormLabel = forwardRef<HTMLLabelElement, Props>(
  ({ text, htmlFor, className, required = true }, ref) => {
    return (
      <RadixLabel.Root
        htmlFor={htmlFor}
        className={twMerge(formLabel({ className }))}
        ref={ref}
      >
        {text}
        {!required && (
          <span className="text-gray-500" aria-hidden="true">
            {" "}
            (optional)
          </span>
        )}
      </RadixLabel.Root>
    );
  },
);

FormLabel.displayName = "FormLabel";

export default FormLabel;
